import React from 'react';
import Home from '../components/homepage/Home';

export default function HomePage() {
  return <Home />;
}
